import React, { createContext, useState, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { useAlert } from '../../alert/containers/AlertProvider'
import {
  getComplaintListApi,
  getTrashTypesApi,
  getNaturesApi,
  cancelComplaintApi,
  assignComplaintApi,
  startProcessingComplaintApi,
  resolveComplaintApi,
  relaunchComplaintApi,
  processedComplaintApi,
  changeComplaintStatusApi,
  resetComplaintStatusApi,
  returnComplaintApi,
  getComplaintOperationListApi,
  getProperIntervenorListApi,
  unresolvedComplaintApi,
} from '../api'
import 'moment/locale/fr'
import { useTranslation } from 'react-i18next'
import { element } from 'prop-types'

moment.locale('fr')

export const ComplaintsContext = createContext()

export const initialFilter = {
  id: 0,
  orderBy: 0,
  natureIds: [],
  trashTypeIds: [],
  date: {
    startDate: null,
    endDate: null,
  },
  statuses: [],
  wilayas: [],
  communes: [],
  startTime: '00:00',
  endTime: '23:59',
  ownerPhoneNumber: '',
  dairaId:[],
}

export const initialOperationFilter = {
  take: 0,
  skip: 0,
}


const initialOperationPagination = { currentPage: 0, take: 10, skip: 0, total: 0 }
const initialPagination = { currentPage: 0, take: 10, skip: 0, total: 0 }

//
const initialPaginationComplaint = { id: 0 }

export const ComplaintsProvider = ({ children }) => {

  const { showAlert } = useAlert()
  const { t, i18n } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)

  const [sendAssignement, setSendAssignement] = useState([])
  const [properintervenor, setProperIntervenor] = useState([])
  const [complaintOperationList, setComplaintOperationList] = useState([])
  const [properIntervenorList, setProperIntervenorList] = useState([])
  const [complaintList, setComplaintList] = useState([])
  const [trashTypes, setTrashTypes] = useState([])
  const [natures, setNatures] = useState([])

  const [operationPagination, setoperationPagination] = useState(initialOperationPagination)
  const [operationFilter, setOperationFilter] = useState(initialOperationFilter)
  const [pagination, setPagination] = useState(initialPagination)
  const [filter, setFilter] = useState(initialFilter)

  const [complaintIdFP, setcomplaintIdFP] = useState(initialPaginationComplaint)

  const handleOperationPagination = ({
    take = operationPagination.take,
    skip = operationPagination.skip,
    currentPage = operationPagination.currentPage,
  }) => {
    setoperationPagination({ ...operationPagination, take, skip, currentPage })
  }

  const handleOperationFilter = (newOperationFilter) => {
    handleOperationPagination({ currentPage: 0, skip: 0 })
    setOperationFilter(newOperationFilter)
  }

  const handlePagination = ({
    take = pagination.take,
    skip = pagination.skip,
    currentPage = pagination.currentPage,
  }) => {
    setPagination({ ...pagination, take, skip, currentPage })
  }

  const handleFilter = (newFilter) => {
    handlePagination({ currentPage: 0, skip: 0 })
    setFilter(newFilter)
  }

  //
  const handleOperationPaginationRefresh = ({
    id = complaintIdFP.id,
  }) => {
    setcomplaintIdFP({ ...complaintIdFP, id })
  }

  const getTrashTypes = async () => {
    try {
      setIsLoading(true)
      const { data } = await getTrashTypesApi()
      setTrashTypes(data)
    } catch {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    } finally {
      setIsLoading(false)
    }
  }

  const getNatures = async () => {
    try {
      setIsLoading(true)
      const { data } = await getNaturesApi()
      setNatures(data)
    } catch {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    } finally {
      setIsLoading(false)
    }
  }

  const getComplaintOperationList = async () => {
    try {
      // edit here
      const { take, skip } = operationPagination
      const {id} = complaintIdFP
      setIsLoading(true)
      
      const { data, headers } = await getComplaintOperationListApi({ complaintId:id, take, skip })
      
      setComplaintOperationList(data)
      
      setoperationPagination({ ...operationPagination, total: headers['x-total-count'] })
    }
    catch (e) {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    } 
    finally {
      setIsLoading(false)
    }
  }

  const getComplaintsList = async () => {
    try {
      const {
        natureIds,
        trashTypeIds,
        wilayas,
        communes,
        date,
        ownerPhoneNumber,
        statuses,
        orderBy,
        id,
        startTime,
        endTime,
        dairaId,
      } = filter
      const { take, skip } = pagination
      setIsLoading(true)

      const requestFilter = {
        ...(id.length > 0 && { id }),
        natureIds,
        trashTypeIds,
        communeIds: communes.map(({ id }) => id),
        dairaIds: dairaId.map(({ id }) => id),
        wilayaIds: communes.length === 0 ? wilayas.map(({ id }) => id) : [],
        orderBy,
        statuses,
        ...(date.startDate !== null && {
          startDate: moment(
            `${date.startDate.format('YYYY-MM-DD')} ${startTime}`,
          ).format(),
        }),
        // add 59 second to end time
        ...(date.endDate !== null && {
          endDate: moment(
            `${date.endDate.format('YYYY-MM-DD')} ${endTime}:59`,
          ).format(),
        }),
        ...(ownerPhoneNumber.length > 3 && { ownerPhoneNumber }),
        take,
        skip,
      }

      const { data, headers } = await getComplaintListApi({
        filter: requestFilter,
      })

      let data2 = data.map( async element => {
        if (element.status === 7) {
          let { data } = await getComplaintOperationListApi({ complaintId:element.id, take:1, skip:1 })
          if (data.length > 0)  return {...element, ownerPhoneNumber: element.ownerPhoneNumber.replace('\+213','0'), prevStatus: data[0].status}
          else  return {...element, ownerPhoneNumber: element.ownerPhoneNumber.replace('\+213','0'), prevStatus: 0}
        }
        else  return {...element, ownerPhoneNumber: element.ownerPhoneNumber.replace('\+213','0')}
      })

      Promise.all(data2).then((data) => {
        setComplaintList(data)
      })

      // here edit, remove later
      // let sortedArrayByLO = await data2.sort((element1, element2) => (new Date(element2.lastOperationDate)) - (new Date(element1.lastOperationDate)) )

      // setComplaintList(sortedArrayByLO)

      setPagination({ ...pagination, total: headers['x-total-count'] })
      
    } 
    catch (e) {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    } 
    finally {
      setIsLoading(false)
    }
  }

  const getProperIntervenorList = async({complaintId}) => {
    try{
      setIsLoading(true)
      setProperIntervenorList([])
      const {data} = await getProperIntervenorListApi({complaintId})
      setProperIntervenor([...properintervenor, { complaintId }])
      setProperIntervenorList(data)
    } catch {
      showAlert({ message: t('showAlert.liste_nest_pas_trouve')})
    } finally {
      setIsLoading(false)
    }
  }

  const assignComplaint = async ({ complaintId, intervenorId }) => {
    try {
      setIsLoading(true)
      await assignComplaintApi({ complaintId, intervenorId })
      setSendAssignement([...sendAssignement, { complaintId, intervenorId }])
      assignComplaintStatus({
        id: complaintId,
      })
      showAlert({
        variant: 'success',
        message: t('showAlert.la_reclamation_a_bien_ete_assignee'),
      })
    } catch (e) {
      if (e?.response?.data?.errorCode === 'DuplicateUserName') {
        showAlert({ message: t('showAlert.cet_assignement_est_deja_fait') })
      } else if ( e?.response?.data?.errorCode === "UserNotSupervisor") {
        showAlert({ message: t('showAlert.vous_netes_pas_autorise_a_effectuer_cette_action') })
      } else {
        showAlert({ message: t('showAlert.une_erreur_est_survenue')})
      }
    } finally {
      setIsLoading(false)
    }
  }

  const returnComplaint = async ({complaintId, comment, otherComment}) => {
    try {
      setIsLoading(true)

      await returnComplaintApi({complaintId, comment, otherComment})
      returnedComplaintStatus({
        id: complaintId,
      })
        showAlert({
          variant: 'success',
          message: t('showAlert.la_reclamation_a_bien_ete_retournee'),
        })
       
    } catch (e) {
      if (e?.response?.data?.errorCode === 'DuplicateUserName') {
        showAlert({ message: t('showAlert.cette_reclamation_est_deja_retournee') })
      } else if ( e?.response?.data?.errorCode === "UserNotSupervisor") {
        showAlert({ message: t('showAlert.vous_netes_pas_autorise_a_effectuer_cette_action') })
      } else {
        showAlert({ message: t('showAlert.une_erreur_est_survenue')})
      }
    }finally {
      setIsLoading(false)
    }
  }

  const startProcessingComplaint = async ({complaintId, timeLimit}) => {
    try {
      setIsLoading(true)

      await startProcessingComplaintApi({complaintId, timeLimit})
      processingComplaintStatus({
        id: complaintId,
      })
      showAlert({
        variant: 'success',
        message: t('showAlert.le_statut_de_traitement_a_bien_ete_envoyee'),
      })
    } catch (e) {
       if ( e?.response?.data?.errorCode === "UserNotSupervisor") {
        showAlert({ message: t('showAlert.vous_netes_pas_autorise_a_effectuer_cette_action') })
      } else {
        showAlert({ message: t('showAlert.une_erreur_est_survenue')})
      }
    }finally {
      setIsLoading(false)
    }
  }

  const processedComplaint = async ({complaintId, pictureLink}) => {
    try {
      setIsLoading(true)

      await processedComplaintApi({complaintId, pictureLink})
      processedComplaintStatus({
        id: complaintId,
      })
      showAlert({
        variant: 'success',
        message: t('showAlert.le_statut_de_traitement_a_bien_ete_envoyee'),
      })
    } catch (e) {
       if ( e?.response?.data?.errorCode === "UserNotSupervisor") {
        showAlert({ message: t('showAlert.vous_netes_pas_autorise_a_effectuer_cette_action') })
      } else {
        showAlert({ message: t('showAlert.une_erreur_est_survenue')})
      }
    }finally {
      setIsLoading(false)
    }
  }

  const cancelComplaint = async({complaintId}) => {
    try {
      setIsLoading(true)

      await cancelComplaintApi({complaintId})
      canceledComplaintStatus({
        id: complaintId,
      })
      showAlert({
        variant: 'success',
        message: t('showAlert.la_reclamation_a_bien_ete_annulee')
      })
    } catch (e) {
       if ( e?.response?.data?.errorCode === "UserNotSupervisor") {
        showAlert({ message: t('showAlert.vous_netes_pas_autorise_a_effectuer_cette_action') })
      } else {
        showAlert({ message: t('showAlert.une_erreur_est_survenue')})
      }
    } finally {
      setIsLoading(false)
    }
  }

  const resolveComplaint = async ({complaintId}) => {
    try {
      setIsLoading(true)

      await resolveComplaintApi({complaintId})
      resolvedComplaintStatus({
        id: complaintId,
      })
      showAlert({
        variant: 'success',
        message: t('showAlert.le_statut_de_traitement_a_bien_ete_resolue'),
      })
    } catch (e) {
       if ( e?.response?.data?.errorCode === "UserNotSupervisor") {
        showAlert({ message: t('showAlert.vous_netes_pas_autorise_a_effectuer_cette_action') })
      } else {
        showAlert({ message: t('showAlert.une_erreur_est_survenue')})
      }
    }finally {
      setIsLoading(false)
    }
  }

  const relaunchComplaint = async ({ complaintId }) => {
    try {
      setIsLoading(true)

      await relaunchComplaintApi({complaintId})
      relaunchComplaintStatus({
        id: complaintId,
      })
      showAlert({
        variant: 'success',
        message: showAlert({ message: t('showAlert.la_reclamation_a_bien_ete_relancee') })
      })
    } catch (e) {
      if ( e?.response?.data?.errorCode === "UserNotPhoneUserOrSupervisor") {
        showAlert({ message: t('showAlert.vous_netes_pas_autorise_a_effectuer_cette_action') })
      } else {
        showAlert({ message: t('showAlert.une_erreur_est_survenue')})
      }
    } finally {
      setIsLoading(false)
    }
  }
  

  const changeComplaintStatus = async ({ complaintsIds, statusType }) => {
    const newStatusTypes = await Promise.all(
      complaintsIds.map((id) =>
        changeComplaintStatusApi({
          id,
          statusType,
        }),
      ),
    )
    setComplaintList(
      complaintList.map((complaint) => {
        if (complaintsIds.indexOf(complaint.id) !== -1) {
          // use newStatusTypes[0].data because all statuses are the same
          return { ...complaint, status: newStatusTypes[0].data }
        }
        return complaint
      }),
    )
  }


  const resetComplaintStatus = async ({ id }) => {
    try {
      resetComplaintStatusApi({ id })
      setComplaintList(
        complaintList.map((complaint) => {
          if (complaint.id === id) {
            return { ...complaint, status: 1 }
          }
          return complaint
        }),
      )
    } catch {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    }
  }

  const canceledComplaintStatus = async ({ id }) => {
    try {
      setComplaintList(
        complaintList.map((complaint) => {
          if (complaint.id === id) {
            return { ...complaint, status: 3 }
          }
          return complaint
        }),
      )
    } catch {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    }
  }

  const assignComplaintStatus = async ({ id }) => {
    try {
      setComplaintList(
        complaintList.map((complaint) => {
          if (complaint.id === id) {
            return { ...complaint, status: 4 }
          }
          return complaint
        }),
      )
    } catch {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    }
  }

  const processingComplaintStatus = async ({ id }) => {
    try {
      setComplaintList(
        complaintList.map((complaint) => {
          if (complaint.id === id) {
            return { ...complaint, status: 5 }
          }
          return complaint
        }),
      )
    } catch {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    }
  }

  const relaunchComplaintStatus = async ({ id }) => {
    try {
      setComplaintList(
        complaintList.map((complaint) => {
          if (complaint.id === id) {
            return { ...complaint, status: 7 }
          }
          return complaint
        })
      )
    } catch {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    }
  }

  const processedComplaintStatus = async ({ id }) => {
    try {
      setComplaintList(
        complaintList.map((complaint) => {
          if (complaint.id === id) {
            return { ...complaint, status: 8 }
          }
          return complaint
        }),
      )
    } catch {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    }
  }

  const returnedComplaintStatus = async ({ id }) => {
    try {
      setComplaintList(
        complaintList.map((complaint) => {
          if (complaint.id === id) {
            return { ...complaint, status: 6 }
          }
          return complaint
        }),
      )
    } catch {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    }
  }

  const resolvedComplaintStatus = async ({ id }) => {
    try {
      setComplaintList(
        complaintList.map((complaint) => {
          if (complaint.id === id) {
            return { ...complaint, status: 2 }
          }
          return complaint
        }),
      )
    } catch {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    }
  }

  const unresolvedComplaint = async ({complaintId}) => {
    try {
      setIsLoading(true)

      await unresolvedComplaintApi({complaintId})
      unresolvedComplaintStatus({
        id: complaintId,
      })
      showAlert({
        variant: 'success',
        message: t('showAlert.le_statut_de_traitement_a_ete_enregistrer_non_traite'),
      })
    } catch (e) {
       if ( e?.response?.data?.errorCode === "UserNotSupervisor") {
        showAlert({ message: t('showAlert.vous_netes_pas_autorise_a_effectuer_cette_action') })
      } else {
        showAlert({ message: t('showAlert.une_erreur_est_survenue')})
      }
    }finally {
      setIsLoading(false)
    }
  }

  const unresolvedComplaintStatus = async ({ id }) => {
    try {
      setComplaintList(
        complaintList.map((complaint) => {
          if (complaint.id === id) {
            return { ...complaint, status: 10 }
          }
          return complaint
        }),
      )
    } catch {
      showAlert({ message: t('showAlert.une_erreur_est_survenue') })
    }
  }

  const init = () => {
    setOperationFilter({ ...initialOperationFilter})
    setoperationPagination({ ...initialOperationPagination})
    setFilter({ ...initialFilter })
    setPagination({ ...initialPagination })
    setcomplaintIdFP({...initialPaginationComplaint})
  }

  const providerValue = {
    init,
    complaintList,
    complaintOperationList,
    trashTypes,
    natures,
    filter,
    operationFilter,
    // here edit
/*     statuses: [
      { id: 1, label: 'Nouvelle' },
      { id: 2, label: 'Résolue' },
      { id: 3, label: 'Annulée' },
      { id: 4, label: 'Envoyée'},
      { id: 5, label: 'En traitement'},
      { id: 6, label: 'Retour'},
      { id: 7, label: 'Relancée'},
      { id: 8, label: 'Traitée'},
      { id: 9, label: 'Confirmée'}
    ], */
/*     statuses: [
      { id: 1, label: t('popOverFilterStatus.new') },
      { id: 2, label: t('popOverFilterStatus.resolved') },
      { id: 3, label: t('popOverFilterStatus.cancelled') },
      { id: 4, label: t('popOverFilterStatus.sent') },
      { id: 5, label: t('popOverFilterStatus.processing') },
      { id: 6, label: t('popOverFilterStatus.sentBack') },
      { id: 7, label: t('popOverFilterStatus.relaunch') },
      { id: 8, label: t('popOverFilterStatus.processed') },
      { id: 9, label: t('popOverFilterStatus.confirmed') },
    ], */
    timeLimits: [
      {id: 1, label: t('timeLimit.oneDay')},
      {id: 2, label: t('timeLimit.twoDays')},
      {id: 3, label: t('timeLimit.threeDays')},
      {id: 4, label: t('timeLimit.fourDays')},
      {id: 5, label: t('timeLimit.fiveDays')}
    ],
    returnCommentaries: [
      { id: 1, label: t('returnCommentaries.commentaryOne')},
      { id: 2, label: t('returnCommentaries.commentaryTwo')}, 
      { id: 3, label: t('returnCommentaries.commentaryThree')},
      { id: 4, label: t('returnCommentaries.commentaryFour')},
      { id: 5, label: t('returnCommentaries.commentaryFive')}
    ],
    statuses: [
      { id: 1, label: t('complaintTab.nouvelle') },
      { id: 2, label: t('complaintTab.resolue') },
      { id: 3, label: t('complaintTab.annule') },
      { id: 4, label: t('complaintTab.assignee')},
      { id: 5, label: t('complaintTab.en_traitement')},
      { id: 6, label: t('complaintTab.returned')},
      { id: 7, label: t('complaintTab.relaunched')},
      { id: 8, label: t('complaintTab.treated')},
      { id: 9, label: t('complaintTab.confirmed')},
      { id: 10, label: t('complaintTab.unresolved')}
    ],
     trashTypesPopOver: [
      {id: 1, label: t('trashTypes.dechet_inertes')},
      {id: 2, label: t('trashTypes.dechet_vert')},
      {id: 3, label: t('trashTypes.dechet_menagers_assimile')},
      {id: 4, label: t('trashTypes.dechet_encombrant')},
      {id: 5, label: t('trashTypes.dechet_mixte')},
    ],
    naturesPopOver: [
      {id: 1, label: t('natures.depotoire_sauvage')},
      {id: 2, label: t('natures.collect_default')},
    ],
    pagination,
    //
    operationPagination,
    isLoading,
    handleFilter,
    handleOperationFilter,
    handlePagination,
    handleOperationPagination,
    cancelComplaint,
    assignComplaint,
    processedComplaint,
    relaunchComplaint,
    startProcessingComplaint,
    getProperIntervenorList,
    properIntervenorList,
    getComplaintsList,
    getComplaintOperationList,
    changeComplaintStatus,
    returnComplaint,
    resolveComplaint,
    resolvedComplaintStatus,
    resetComplaintStatus,
    assignComplaintStatus,
    processingComplaintStatus,
    returnedComplaintStatus,
    processedComplaintStatus,
    unresolvedComplaint,
    unresolvedComplaintStatus,
    handleOperationPaginationRefresh
  }

  useEffect(() => {
    if (natures.length > 0 && trashTypes.length > 0) {
      getComplaintsList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, pagination.take, pagination.skip, natures, trashTypes])

  useEffect(() => {
    getNatures()
    getTrashTypes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // this updates the view when change occurs in parameters
  useEffect(() => {
    getComplaintOperationList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [complaintIdFP.id, operationPagination.take, operationPagination.skip, operationPagination.currentPage, operationPagination.total])

  return (
    <ComplaintsContext.Provider value={providerValue}>
      {children}
    </ComplaintsContext.Provider>
  )
}
ComplaintsProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export const useComplaints = () => {
  const context = useContext(ComplaintsContext)
  if (context === undefined) {
    throw new Error('useComplaints must be used within a ComplaintsProvider')
  }
  return context
}
